<template>
<div class="tool-tip">
    <i class="fas fa-info-circle control" @mouseover="showContent = true" @mouseleave="showContent = false"></i>
    <div v-if="showContent" class="tool-tip-content" :style="'width: ' + boxWidth + 'em; left: ' + left + 'em;'">
        {{ content }}
    </div>
</div>
</template>
<script>
export default {
    name: 'tool-tip',
    props: {
        content: {
            type: String,
            required: true
        },
        left: {
            type: [String, Number],
            required: false,
            default: 1.5
        }
    },
    data() {
        return {
            showContent: false
        }
    },
    computed: {
        boxWidth() {
            return Math.max(Math.ceil(this.content.length / 25), 25)
        }
    }
}
</script>

<style lang="scss" scoped>
.tool-tip {
    display: inline-block;
    padding: 0 0 0 0.25em;
    position: relative;
}
.control {
    opacity: 0.7;
}
.control:hover {
    opacity: 1;
    cursor: pointer;
}
.tool-tip-content {
    z-index: 1000;
    position: absolute;
    bottom: 1.25em; //left: 1.5em;
    background-color: white;
    border: 1px solid #aaa !important;
    //box-shadow: 0 0 3px 1px #e4e4e4;
    color: #000000;
    font-size: 0.85em;
    font-family: Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    text-transform: none;
    padding: 0.5em;
}
</style>
